/**
 * Shown in place of a date that doesn't exist yet — a program that has never
 * paid out, for example.
 *
 * Two hyphens, matching the canvas, which renders `<span class="dash">--</span>`
 * for every absent date (Last payment, Sub IB since). The canvas also dims it
 * (`.dash { color: var(--text-disabled) }`), which the table cells do via
 * `text-text-disabled` on the surrounding `Typo`.
 *
 * Shared by this report's three date formatters so they cannot drift. Their
 * non-empty output is deliberately left alone: `rebate-programs/data.ts` hand
 * rolls its month names while the others use `toLocaleDateString`, so merging
 * them would risk changing formatted dates, which is not what this is for.
 */
export const EMPTY_DATE = "--";

/**
 * Character cap for every Sub IB comment field (design change #1, PART-3930 —
 * was 500 on the old multi-line TextareaV2). Passed to `InputV2` as
 * `characterLimit`, which both renders the in-field `N/60` counter and hard
 * blocks typing at the cap via `maxLength` — so callers must not add a counter
 * of their own.
 *
 * Shared by the edit-comment modal, the Sub IB drawer's inline editor, and the
 * wizard's relationship step so the three cannot drift apart.
 */
export const COMMENT_CHARACTER_LIMIT = 60;

/**
 * Failed-save message for design changes #2 (comment save) and #3 (permission
 * settings save), PART-3930. Design-verbatim — **no terminal full stop**.
 *
 * #2 renders it through `InputV2`'s `error` prop (ring + AlertTriangle glyph
 * come with it); #3 renders it as a hand-built inline line below the toggle row.
 */
export const SAVE_ERROR_MESSAGE = "Something went wrong, try again later";

export const SUPPORT_EMAIL = "support@pepperstonepartners.com";
